import { TRoomsParams } from 'common/types/floor-params.type';
import { hasMatchingDimensions } from 'common/helpers/has-matching-dimensions.helper';
import { hasMatchingArea } from 'common/helpers/has-matching-area.helper';
import { hasMatchingTypeInstallation } from 'common/helpers/has-matching-type-installation';
import { LaminateInputs } from '../../../types';
import { hasMatchingRoomType } from './has-matching-room-type';

type TParams = {
  dataInRooms: TRoomsParams[];
  inputParams: LaminateInputs;
};

export const getRoomIdsWithSameInputParams = ({ dataInRooms, inputParams }: TParams): string[] => {
  const hasDimensions = Boolean(inputParams.length) && Boolean(inputParams.width);

  const inputArea = Boolean(inputParams.area) ? Number(inputParams.area) : null;

  const sameRooms = dataInRooms.filter(item => {
    const itemLength = item.length ?? undefined;
    const itemWidth = item.width ?? undefined;
    const itemArea = item.square ?? null;
    const itemTypeInstallation = item.typeInstallation ?? null;
    const isTypeInstallationsEqual = hasMatchingTypeInstallation({
      itemTypeInstallation,
      typeInstallation: inputParams.layingType,
    });
    const isRoomTypesEqual = hasMatchingRoomType({
      itemRoomType: item.roomType,
      roomType: inputParams.roomType,
    });
    const isTypeInstallationsAndRoomTypesEqual = isTypeInstallationsEqual && isRoomTypesEqual;

    if (hasDimensions) {
      return (
        isTypeInstallationsAndRoomTypesEqual &&
        hasMatchingDimensions(itemLength, itemWidth, Number(inputParams.length), Number(inputParams.width))
      );
    }

    return isTypeInstallationsAndRoomTypesEqual && hasMatchingArea(itemArea, inputArea);
  });

  return sameRooms.map(room => room.id);
};
